import { Checkbox, CheckboxProps } from '@chakra-ui/react';

import InputTooltip from '../Input/InputTooltip';
import { Container } from './styles';

interface ICustomCheckboxProps extends CheckboxProps {
  hasBorder?: boolean;
  isRounded?: boolean;
  children?: React.ReactNode;
  tooltip?: string;
}

const CustomCheckbox: React.FC<ICustomCheckboxProps> = ({
  hasBorder = false,
  isRounded = false,
  children,
  tooltip,
  ...rest
}) => (
  <Container className="checkbox" isRounded={isRounded} border={hasBorder}>
    <Checkbox {...rest}>
      {children}

      {tooltip && <InputTooltip label={tooltip} />}
    </Checkbox>
  </Container>
);

export default CustomCheckbox;
